import React from 'react';

import AlertsPanel from 'components/experiment/ui/AlertsPanel.component';
import BadgesPanel from 'components/experiment/ui/BadgesPanel.component';
import BulletsPanel from 'components/experiment/ui/BulletsPanel.component';
import ButtonsPanel from 'components/experiment/ui/ButtonsPanel.component';
import ColorsPanel from 'components/experiment/ui/ColorsPanel.component';
import DatePanel from 'components/experiment/ui/DatePanel.component';
import DateTimePanelUi from 'components/experiment/ui/DateTimePanelUi.component';
import DepositPanelUi from 'components/experiment/ui/DepositPanelUi.component';
import DropdownPanelUi from 'components/experiment/ui/DropdownPanelUi.component';
import FormControlsPanel from 'components/experiment/ui/FormControlsPanel.component';
import ModalsPanel from 'components/experiment/ui/ModalsPanel.component';
import ProgressBarPanel from 'components/experiment/ui/ProgressBarPanel.component';
import TooltipPanel from 'components/experiment/ui/TooltipPanel.component';
import Foldout from 'components/generic/Foldout.component';

import IconsPanel from './IconsPanel.component';

import CN from './UiPage.module.scss'; // Since this is experiment, we can share the same .module.scss file

// TODO: maybe add tab navigation between different panels
const UiPage = () => (
  <div data-bem="UiPage" className={CN.component}>
    <Foldout tag="UiPage__buttons" title="MODALS">
      <ModalsPanel />
    </Foldout>
    <Foldout tag="UiPage__buttons" title="BUTTONS">
      <ButtonsPanel />
    </Foldout>
    <Foldout tag="UiPage__checkbox-radio-toggler" title="CHECKBOX RADIO TOGGLER">
      <FormControlsPanel />
    </Foldout>
    <Foldout tag="UiPage__badges" title="BADGES">
      <BadgesPanel />
    </Foldout>
    <Foldout tag="UiPage__tooltips" title="TOOLTIPS">
      <TooltipPanel />
    </Foldout>
    <Foldout tag="UiPage__icons" title="ICONS">
      <IconsPanel />
    </Foldout>
    <Foldout tag="UiPage__alerts" title="ALERTS">
      <AlertsPanel />
    </Foldout>
    <Foldout tag="UiPage__deposit" title="DEPOSIT APPOINTMENT STATUSES">
      <DepositPanelUi />
    </Foldout>
    <Foldout tag="UiPage__dropdown" title="DROPDOWNS">
      <DropdownPanelUi />
    </Foldout>
    <Foldout tag="UiPage__progress-bar" title="PROGRESS BAR">
      <ProgressBarPanel />
    </Foldout>
    <Foldout tag="UiPage__bullets" title="BULLETS">
      <BulletsPanel />
    </Foldout>
    <Foldout tag="UiPage__colors" title="COLORS">
      <ColorsPanel />
    </Foldout>
    <Foldout tag="UiPage__date-picker" title="DATE PICKER">
      <DatePanel />
    </Foldout>
    <Foldout tag="UiPage__date-time-formats" title="DATE TIME FORMATS">
      <DateTimePanelUi />
    </Foldout>
  </div>
);

export default UiPage;
